/// <reference types="@capacitor/cli" />
export var SystemBarsStyle;
(function (SystemBarsStyle) {
    /**
     * Light system bar content on a dark background.
     */
    SystemBarsStyle["Dark"] = "DARK";
    /**
     * For dark system bar content on a light background.
     */
    SystemBarsStyle["Light"] = "LIGHT";
    /**
     * The style is based on the device appearance or the underlying content.
     * If the device is using dark mode, the system bars content will be light.
     * If the device is using light mode, the system bars content will be dark.
     */
    SystemBarsStyle["Default"] = "DEFAULT";
})(SystemBarsStyle || (SystemBarsStyle = {}));
export var SystemBarsType;
(function (SystemBarsType) {
    /**
     * The top status bar on both Android and iOS.
     */
    SystemBarsType["StatusBar"] = "STATUS_BAR";
    /**
     * The navigation bar on both Android and iOS.
     *
     * On iOS this is the "home indicator".
     *
     * On Android this is either the "navigation bar" or the "gesture bar".
     */
    SystemBarsType["NavigationBar"] = "NAVIGATION_BAR";
})(SystemBarsType || (SystemBarsType = {}));
//# sourceMappingURL=definitions.js.map